var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-msg"},[_c('span',{staticClass:"t-msg__close",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.closeMsg()}}}),_vm._v(" "),_c('div',{staticClass:"t-msg__text",domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-135c8651","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue_components/Msg.vue
// module id = 474
// module chunks = 0